import script from "./CrmSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./CrmSidebar.vue?vue&type=script&setup=true&lang=js"

import "./CrmSidebar.vue?vue&type=style&index=0&id=758a6512&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-758a6512"]])

export default __exports__